/*@flow*/
import mkLeafletBbox from 'lib/mkLeafletBbox';

export default function getBboxCenter(bboxString: string): void | Array<any> {
  if (!bboxString) return;
  const bbox = mkLeafletBbox(bboxString);
  const center = bbox.getCenter();
  return [center.lat, center.lng];
}
